import lodashPull from "lodash/pull";

import {
  GET_USER_ALERTS,
  GET_USER_ALERTED_CONTENT,
  SAVE_USER_ALERT,
  DELETE_USER_ALERT,
  DELETE_SHARED_ALERT,
  OPEN_ALERT_WIZARD,
  CLOSE_ALERT_WIZARD,
  SAVE_MAPPED_ALERTS,
  GET_ALERTS_REFRESH_MAP,
  GET_TRIGGERED_ALERTS,
  CLEAR_TRIGGERED_ALERTS,
  ADD_TRIGGERED_ALERT,
  ADD_TRIGGERED_ALERTS,
  REMOVE_TRIGGERED_ALERT,
} from "./actions.type";
import {
  SET_MAPPED_ALERTS,
  SET_ALERT_LOADING,
  SET_USER_ALERTS,
  SET_USER_ALERTED_CONTENT,
  SAVING_USER_ALERT,
  DELETING_USER_ALERT,
  SET_DISPLAY_WIZARD,
  SET_WIZARD_DETAILS,
  UNSUBSCRIBING_USER_ALERT,
  SET_ALERTS_REFRESH_MAP,
  SET_TRIGGERED_ALERTS,
} from "./mutations.type";
import {
  getAlerts,
  getContent,
  deleteAlert,
  saveAlert,
  deleteSharedAlert,
  getTriggerRecords,
} from "@/services/alerts/alerts.service";
import { setInfiniteScrollState } from "@/common/basic.utilities";

const STATE = {
  loading: false,
  contentLoading: false,
  saving: false,
  deleting: false,
  displayWizard: false,
  error: null,
  alerts: [],
  mappedContent: null,
  wizardDetails: {},
  mapped: [],
  triggered: [],
};

const GETTERS = {
  loading: (state) => state.loading,
  alerts: (state) => state.alerts,
  saving: (state) => state.saving,
  deleting: (state) => state.deleting,
  displayWizard: (state) => state.displayWizard,
  wizardDetails: (state) => state.wizardDetails,
  mappedContent: (state) => state.mappedContent,
  mapped: (state) => state.mapped,
  triggered: (state) => state.triggered,
};

const ACTIONS = {
  async [GET_USER_ALERTS](context, params) {
    try {
      context.commit(SET_ALERT_LOADING, true);
      let RESULT = await getAlerts(params);
      context.commit(SET_USER_ALERTS, RESULT);
    } catch (error) {
      console.error("Error in GET_USER_ALERTS actions: " + error);
    } finally {
      context.commit(SET_ALERT_LOADING, false);
    }
  },
  async [GET_USER_ALERTED_CONTENT](context, params) {
    let RESULT;
    try {
      context.commit(SET_ALERT_LOADING, true);
      RESULT = await getContent(params);
      RESULT.isConcat = !!params.$state;
      context.commit(SET_USER_ALERTED_CONTENT, RESULT);
      context.commit(SET_ALERT_LOADING, false);
    } catch (error) {
      console.error("Error in GET_USER_ALERTED_CONTENT actions: " + error);
    } finally {
      if (RESULT.isConcat) {
        setInfiniteScrollState(params.$state, RESULT, "data");
      }
      context.commit(SET_ALERT_LOADING, false);
    }
  },
  async [DELETE_USER_ALERT](context, params) {
    try {
      context.commit(DELETING_USER_ALERT, true);
      await deleteAlert(params);
      context.commit(DELETING_USER_ALERT, false);
      context.dispatch(GET_USER_ALERTS);
    } catch (error) {
      console.error("Error in DELETE_USER_ALERT actions: " + error);
    } finally {
      context.commit(DELETING_USER_ALERT, false);
    }
  },
  async [DELETE_SHARED_ALERT](context, params) {
    try {
      context.commit(DELETING_USER_ALERT, true);
      await deleteSharedAlert(params);
      context.commit(DELETING_USER_ALERT, false);
      context.dispatch(GET_USER_ALERTS);
    } catch (error) {
      console.error("Error in UNSUBSCRIBE_USER_ALERT actions: " + error);
    } finally {
      context.commit(UNSUBSCRIBING_USER_ALERT, false);
    }
  },
  async [SAVE_USER_ALERT](context, params) {
    try {
      context.commit(SAVING_USER_ALERT, true);
      await saveAlert(params);
      context.commit(SAVING_USER_ALERT, false);
      context.commit(SET_DISPLAY_WIZARD, false);
      context.dispatch(GET_USER_ALERTS);
    } catch (error) {
      console.error("Error in SAVE_USER_ALERT actions: " + error);
    } finally {
      context.commit(SAVING_USER_ALERT, false);
    }
  },
  [OPEN_ALERT_WIZARD](context, params) {
    try {
      context.commit(SET_WIZARD_DETAILS, params);
      context.commit(SET_DISPLAY_WIZARD, true);
    } catch (error) {
      console.error("Error in OPEN_ALERT_WIZARD actions: " + error);
    }
  },
  [CLOSE_ALERT_WIZARD](context, params) {
    try {
      context.commit(SET_DISPLAY_WIZARD, false);
      context.commit(SET_WIZARD_DETAILS, {});
    } catch (error) {
      console.error("Error in CLOSE_ALERT_WIZARD actions: " + error);
    }
  },
  [SAVE_MAPPED_ALERTS](context, params) {
    try {
      context.commit(SET_MAPPED_ALERTS, params);
    } catch (error) {
      console.error("Error in SAVE_MAPPED_ALERTS: " + error);
    }
  },
  [GET_ALERTS_REFRESH_MAP](context, params) {
    context.commit(SET_ALERTS_REFRESH_MAP, params);
  },
  async [GET_TRIGGERED_ALERTS](context, params) {
    try {
      params.alertsIdFilter = [];
      const alerts = await getTriggerRecords(params);
      if (params.append === true) {
        context.commit(ADD_TRIGGERED_ALERTS, alerts);
      } else {
        context.commit(SET_TRIGGERED_ALERTS, alerts);
      }
    } catch (error) {
      console.error("Error in GET_TRIGGERED_ALERTS actions: " + error);
    }
  },
  async [CLEAR_TRIGGERED_ALERTS](context, params) {
    context.commit(SET_TRIGGERED_ALERTS, []);
  },
  async [ADD_TRIGGERED_ALERT](context, params) {
    context.commit(ADD_TRIGGERED_ALERT, params);
  },
  async [ADD_TRIGGERED_ALERTS](context, params) {
    context.commit(ADD_TRIGGERED_ALERTS, params);
  },
  async [REMOVE_TRIGGERED_ALERT](context, params) {
    context.commit(REMOVE_TRIGGERED_ALERT, params);
  },
};

const MUTATIONS = {
  [SET_ALERT_LOADING](state, data) {
    state.loading = data;
  },
  [SET_USER_ALERTS](state, data) {
    state.alerts = data;
  },
  [SAVING_USER_ALERT](state, data) {
    state.saving = data;
  },
  [DELETING_USER_ALERT](state, data) {
    state.deleting = data;
  },
  [SET_DISPLAY_WIZARD](state, data) {
    state.displayWizard = data;
  },
  [SET_WIZARD_DETAILS](state, data) {
    state.wizardDetails = data;
  },
  [SET_MAPPED_ALERTS](state, data) {
    if (state.mapped.includes(data)) {
      lodashPull(state.mapped, data);
    } else {
      state.mapped.push(data);
    }
  },
  [UNSUBSCRIBING_USER_ALERT](state, data) {
    state.unsubscribing = data;
  },
  [SET_TRIGGERED_ALERTS](state, data) {
    state.triggered = data;
  },
  [ADD_TRIGGERED_ALERT](state, data) {
    if (!state.triggered) {
      state.triggered = [];
    }
    state.triggered.push(data);
  },
  [ADD_TRIGGERED_ALERTS](state, data) {
    if (!state.triggered) {
      state.triggered = [];
    }
    if (data.length != 0) {
      state.triggered.push(...data);
    }
  },
  [REMOVE_TRIGGERED_ALERT](state, data) {
    if (!state.triggered) {
      state.triggered = [];
    } else {
      state.triggered.forEach(function (alert, i, array) {
        if (alert.triggeredId === data) {
          array.splice(i, 1);
        }
      });
    }
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
